export default "__VITE_ASSET__3c60ef2d__"